import ReactComponent from '../../../assets/icons/analysis.svg?react';
import type { FC } from 'react';
import { BaseIcon, IconProps } from './BaseIcon';

export const AnalysisIcon: FC<IconProps> = (props) => {
    return (
        <BaseIcon {...props}>
            <ReactComponent />
        </BaseIcon>
    );
};
